function IngredientView(props) {
  return (
    <div className="ingredientLine">
      <p>{props.ingredient}</p>
    </div>
  );
}

export default IngredientView;
